﻿'use strict';
/**
 * [init getting images for vimeo]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope) {
    $('img[id^="vimeo"]').each(function() {
        var $img = $(this);
        var id = $img.attr('id').replace('vimeo-', '');
        $.ajax({
            type: 'GET',
            url: 'https://vimeo.com/api/v2/video/' + id + '.json',
            jsonp: 'callback',
            dataType: 'jsonp',
            success: function(data) {
                var thumbnailSrc = data[0].thumbnail_large;
                $img.attr('src', thumbnailSrc);
            }
        });
    });
}
